import React from "react";
import EditIcon from "@mui/icons-material/Edit";
// import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
// import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";

export default function GameVersion() {
  const { showPage, setShowPage, accessObject } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  // const [searchTourName] = React.useState();
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const LoginSchema = Yup.object().shape({
    gameName: Yup.string().required("required"),
    androidVersion: Yup.string().required("required"),
    iosVersion: Yup.string().required("required"),
  });

  React.useEffect(() => {
    getBranch();
  }, []);

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/game-version/get-game-version`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);
        console.log("dataTable.dataRows :::", response.data.data);
        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };
  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  // const searchingData = [];
  // let data = [];
  // console.log("tableData 111 ---", tableData, searchTourName);
  // if (searchTourName) {
  //   console.log("tableData 222 ---", tableData, tableData.length > 0);
  //   data = tableData.filter((item) => {
  //     return Object.values(item?.tourName)
  //       .join("")
  //       .includes(searchTourName.toLowerCase());
  //   });
  //   console.log("data 111 ---", data);
  //   data?.map((dataItem) => searchingData.push(dataItem));
  // } else {
  //   tableData.map((dataItem) => searchingData.push(dataItem));
  // }

  const clickEditButton = (item) => {
    setShowPage(true);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateTournament = (value) => {
    console.log("updateTournament merged value :::", value);

    axios
      .patch(
        `${API_URL}/api/admin/game-version/update-game-version/${rowValue._id}`,
        value
      )
      .then((res) => {
        console.log("updateTournament update :::", res.data);
        if (res.data.status) {
          successEdit(res.data.message);
          setbuttonLoader(false);
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        setbuttonLoader(false);
        console.log("updateTournament err :::", err);
        warningAlert();
      });
  };

  const addNewTournament = (value) => {
    console.log("addNewTournament ---", value);

    axios(`${API_URL}/api/admin/game-version/add-game-version`, {
      method: "POST",
      credentials: "include",
      data: value,
    })
      .then((result) => {
        console.log("addNewTournament result :::", result.data);
        if (result.data.status) {
          setbuttonLoader(false);
          successAdd();
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("addNewTournament err :::", err);
        warningAlert();
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this game version. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">The game version has been successfully removed.</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    axios
      .post(`${API_URL}/api/game-version/delete-game-version/${e._id}`)
      .then((res) => {
        if (res.data.status) {
          successDeleted();
        }
        getBranch();
      });
  };

  const successAdd = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">The game version has been added successfully.</p>
      </SweetAlert>
    );
  };

  const successEdit = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">The game version has been updated successfully.</p>
      </SweetAlert>
    );
  };

  const warningAlert = () => {
    setAlert(
      <SweetAlert
        warning
        onConfirm={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Wait!</div>
        <p className="premium-alert-text">Something went wrong. Please try again later.</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  gameName: rowValue ? rowValue.gameName : "",
                  androidVersion: rowValue ? rowValue.androidVersion : "",
                  iosVersion: rowValue ? rowValue.iosVersion : "",
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  console.log(values);

                  if (openValue == 1) {
                    console.log("update formik value :::", openValue);
                    addNewTournament(values);
                  }
                  if (openValue == 2) {
                    console.log("update formik value :::", openValue);
                    updateTournament(values);
                  }
                }}
              >
                {({ touched, errors, isSubmitting, values, setFieldValue }) => (
                  <div>
                    <Form>
                      {/* gameName */}
                      <div className="form-group">
                        <label htmlFor="password" className="mt-3">
                          Game Name
                        </label>
                        <Field
                          type="text"
                          name="gameName"
                          placeholder="Game Name"
                          // disabled={
                          //   accessObject?.bonusEdit == true ? false : true
                          // }
                          className={` form-control
                          ${
                            touched.gameName && errors.gameName
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="gameName"
                          className="invalid-feedback"
                        />
                      </div>
                      {/* androidVersion */}
                      <div className="form-group">
                        <label htmlFor="password" className="mt-3">
                          Android Version
                        </label>
                        <Field
                          type="number"
                          name="androidVersion"
                          placeholder="Android Version"
                          // disabled={
                          //   accessObject?.bonusEdit == true ? false : true
                          // }
                          className={` form-control
                          ${
                            touched.androidVersion && errors.androidVersion
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="androidVersion"
                          className="invalid-feedback"
                        />
                      </div>
                      {/* iosVersion */}
                      <div className="form-group">
                        <label htmlFor="password" className="mt-3">
                          IOS Version
                        </label>
                        <Field
                          type="number"
                          name="iosVersion"
                          placeholder="IOS Version"
                          // disabled={
                          //   accessObject?.bonusEdit == true ? false : true
                          // }
                          className={` form-control
                          ${
                            touched.iosVersion && errors.iosVersion
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="iosVersion"
                          className="invalid-feedback"
                        />
                      </div>
                      <button
                        style={{ width: "100px", color: "#000" }}
                        type="submit"
                        className="btn btn-primary btn-block mt-4 mr-2"
                        disabled={buttonLoader}
                      >
                        <div
                          className="d-flex"
                          style={{
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            className="d-flex"
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <b>Submit</b>
                          </div>
                          {buttonLoader && (
                            <div>
                              <div
                                class="spinner-border ml-2 mt-1"
                                role="status"
                                style={{ height: "20px", width: "20px" }}
                              ></div>
                            </div>
                          )}
                        </div>
                      </button>
                    </Form>
                  </div>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card ">
            {/* <div
              class="pl-4 pr-4 pt-4"
              style={{ display: "flex", justifyContent: "space-between" }}
                          > */}
            {/* <div className="row pl-4 pr-4 pt-4">
              <div className="col-5">
                <button
                  style={{ width: "118px" }}
                  onClick={() => {
                    openAddTournament(1);
                  }}
                  type="button"
                  className="btn btn-primary btn-block "
                >
                  <AddIcon />
                  Add New
                </button>
              </div>
              <div className="col-7">
                <h3 class="card-title">
                  <b>Bot List</b>
                </h3>
              </div>
            </div> */}

            {/* <div style={{ display: "none" }}>
                <b className="mr-2">Tournament Name :</b>
                <input
                  placeholder="Enter Tournament Name"
                  value={searchSubType}
                  onChange={(e) => setSearchTourName(e.target.value)}
                />
              </div> */}
            {/* </div> */}

            <div class="card-body" style={{ overflow: "scroll" }}>
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Game Name</th>
                    <th>Android Version</th>
                    <th>IOS Version</th>
                    {accessObject?.editGameVersion == true && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {!loader ? (
                    <>
                      {tableData.length > 0 ? (
                        <>
                          {tableData
                            ?.slice(pagination.start, pagination.end)
                            .map((item, index) => (
                              <>
                                <tr key={index}>
                                  <td>{index + 1 + pagination.start}</td>
                                  <td>{item.gameName}</td>
                                  <td>{item.androidVersion}</td>
                                  <td>{item.iosVersion}</td>
                                  {accessObject?.editGameVersion == true && (
                                    <td className="justify-content-evenly">
                                      <div className="d-flex">
                                        <EditIcon
                                          className="mr-3 courser"
                                          onClick={() => clickEditButton(item)}
                                        />
                                        {/* <ClearIcon
                                        className="courser text-danger"
                                        onClick={() =>
                                          warningWithConfirmMessage(item)
                                        }
                                      /> */}
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              </>
                            ))}
                        </>
                      ) : (
                        <EmptyState colSpan={5} />
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </tbody>
              </table>
              <div className="mt-4">{loader && <Loader />}</div>
            </div>
            {tableData.length != 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={tableData.length}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
